import React from "react";
// import { withBottombar } from "../../HOCs";
import MyBookingList from "./myBookingList";
class MyBookingListParent extends React.Component {
  render() {
    return <MyBookingList />;
  }
}
export default MyBookingListParent